export default __webpack_public_path__ + "static/media/alarm.89021324.svg";